import DashboardState from "./DashboardState";
import { svg } from "../../../resources/Svg";
import { useAuth } from "../../../contexts/AuthContext";

import { useEffect } from "react";

const Overview = () => {
  const {
    userInfo,
    totalExpenses,
    setTotalExpenses,
    totalMargin,
    totalRevenue,
  } = useAuth();

  useEffect(() => {
    setTotalExpenses(totalExpenses);
  }, [totalExpenses, setTotalExpenses, totalRevenue]);

  return (
    <>
      <div className="px-8 pt-8 flex flex-col space-y-2">
        <h1 className="text-md font-semibold text-gray-700">
          Overview (Current Month)
        </h1>
        {/**States*/}
        <div className="w-full flex space-x-2 items-center ">
          <DashboardState
            svg={svg.balance}
            text={userInfo?.isSalary ? "Monthly Balance" : "Monthly Revenue"}
            amount={
              userInfo?.isSalary
                ? userInfo?.salaryDetails?.monthlySalary
                  ? userInfo?.salaryDetails?.monthlySalary
                  : 0
                : totalRevenue
                ? totalRevenue
                : 0
            }
            flag={"green-500"}
          />
          <DashboardState
            svg={svg.warning}
            text="Total Expenses"
            amount={totalExpenses ? totalExpenses : 0}
            flag={"yellow-500"}
          />

          <DashboardState
            svg={svg.updown}
            text="Margin"
            flag={"blue-500"}
            amount={totalMargin ? totalMargin : 0}
          />
        </div>
      </div>
    </>
  );
};

export default Overview;
